import React, { Component, Fragment } from 'react';
import background from '../assets/images/gradient-bg.png';

class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestFailed: false,
    };
  }

  render() {
    return (this.props.site_info.hero_image.path) ? (
      <Fragment>
        <section className="hero-block">
          <img className="hero-image" src={process.env.REACT_APP_COCKPIT_URL + this.props.site_info.hero_image.path} alt={this.props.site_info.tagline} />
          <h1>{this.props.site_info.site_title}</h1>
          <h2 className="tagline">{this.props.site_info.tagline}</h2>
        </section>
      </Fragment>
    ) : (
      <Fragment>
        <section className="hero-block">
          <img className="hero-image" src={background} alt={this.props.site_info.tagline} />
          <h1>{this.props.site_info.site_title}</h1>
          <h2>{this.props.site_info.tagline}</h2>
        </section>
      </Fragment>
    );
  }
}

export default Hero;
